

import * as yup from "yup";

export const ImageInput = [
    {
        name: 'image',
        type: 'file',
        uploadImgDivStyle: {
            width: '173px',
            height: '154px',
            position: 'absolute',
            top: '-26px',
        }
    }
]

export const Inputs = [
    {
        name: "name",
        type: "text",
        icon: 'fas fa-user fa-2x',
        placeholder: { ar: 'اسم المستخدم', en: "Username" },
        col: "12",
    },
    {
        name: "phone",
        type: "text",
        limit:11,
            inputType:"number",

        icon: 'fas fa-mobile-alt fa-2x',
        placeholder: { ar: 'رقم الموبايل', en: "Phone Number" },
        col: "12",
    },
    {
        name: "email",
        type: "text",
        confirmBtn: { ar: 'تاكيد', en: 'confirm' },
        placeholder: { ar: 'البريد الالكتروني', en: "Email" },
        col: "12",
    },
    {
        name: "password",
        type: "password",
        isPassword: true,
        icon: ['fas fa-eye fa-2x', 'fas fa-eye-slash fa-2x'],
        placeholder: { ar: 'كلمة المرور', en: "Password" },
        col: "12",
    },
    {
        name: "confirmpassword",
        type: "password",
        isPassword: true,
        icon: ['fas fa-eye fa-2x', 'fas fa-eye-slash fa-2x'],
        placeholder: { ar: 'تاكيد كلمة المرور', en: "Confirm Password" },
        col: "12",
    }
]

export const config = {
    url: '/signup',
    sendEmail: '/verifyEmail',
    sendMail_Label: ["email", "email"],  //[key in the request , name of element]
    confirmMail: '/confirmEmailCode',
    confirmMail_label: ['email', 'email', 'code'],   //[first key in request , name of element, second key in request]
    redirect: false,
    haveOneImg: true,
    signUpFlag: true,
    Sendbtn: { ar: 'تسجيل', en: 'Register' },
    submitLabels: ["image", "name", "phone", "email", "password"]
}
export const Validation = yup.object().shape({
 
    // image: yup.mixed().required({ar:'يجب ادخال صورة الشخص *',en:'Image is required *'}),
    name: yup.string().required({ar:"يجب ادخال اسم الشخص *",en:"Name is required *"}),
    phone: yup.string().required({ar:'يجب ادخال  رقم الموبايل *',en:'Phone number is not valid *'}).typeError({ar:'يجب ادخال  رقم الموبايل *',en:'Phone number is not valid *'}),
    email: yup.string().email({ar:"  البريد الالكتروني غير صحيح *",en:"Invalid Email*"}).required({ar:"يجب ادخال البريد الالكتروني *",en:"Email is required *"}),
    password: yup.string().required({ar:"يجب ادخال كلمة المرور *",en:"Password is required *"}),
    confirmpassword: yup.string().required({ar:"يجب ادخال كلمة المرور *",en:"Password is required *"})
      .test('passwords-match', {ar:'كلمة المرور لا تتطابق',en:"Password not Matched"}, function (value) {
        return this.parent.password === value;
      }),
})